// extracted by mini-css-extract-plugin
export var Body = "layout-module--Body--amhhM";
export var Footer = "layout-module--Footer--WyvI6";
export var Header = "layout-module--Header--KSojb";
export var InView = "layout-module--InView--eHasf";
export var OutView = "layout-module--OutView--jHr2E";
export var Wrapper = "layout-module--Wrapper--O-rbM";